import React, { Component } from 'react';
import { connect } from 'react-redux';
import Wrapper from '../index';
import Sidebar from '../cod/Sidebar';
import MariyaTable from './items/Table';
import api from '../../../api';
import { booleanConverter, createFilter, dateConverter, lowerCaseStringConverter } from '../../../helpers/filterConverters';
import sortConverter from '../../../helpers/sortConverter';

const convertersMap = {
    Blockage: dateConverter,
    Blocked: booleanConverter,
    Location: lowerCaseStringConverter,
    Number: lowerCaseStringConverter
};

class Mariya extends Component {
    state = {
        count: 0,
        data: [],
        filtered: [],
        getDataStatus: 'idle',
        index: null,
        page: 0,
        pageSize: 10,
        rowID: null,
        sorted: [{ id: 'Location', desc: false }]
    };

    componentDidMount() {
        this.handleGetData();
    }

    buildRequestParams = () => {
        const { page, pageSize, filtered, sorted } = this.state;

        return {
            filter: createFilter(filtered, convertersMap),
            order: sortConverter(sorted),
            top: pageSize,
            skip: page * pageSize
        };
    }

    handleGetData = async () => {
        this.setState({ getDataStatus: 'pending' });

        const params = this.buildRequestParams();
        const res = await api.apiGetMariya(params);
        const list = (res && res.data && res.data.value) || [];

        this.setState({
            data: list,
            count: res.data['@odata.count'] || list.length,
            getDataStatus: 'success'
        });
    }

    handleChangePageSize = (pageSize) => this.setState({ page: 0, pageSize }, this.handleGetData);

    handleChangePage = (page) => this.setState({ page }, this.handleGetData);

    handleOnFilterChange = (filtered = []) => {
        const serialize = arr => arr.map(f => `${f.id}=${JSON.stringify(f.value)}`).sort().join('|');
        const serverChanged = serialize(this.state.filtered) !== serialize(filtered);

        this.setState({ filtered, page: serverChanged ? 0 : this.state.page }, () => {
            if (serverChanged) this.handleGetData();
        });
    }

    handleOnSortChange = (sorted = []) => this.setState({ sorted }, this.handleGetData);

    handleClearFilter = () => {
        const hadFilters = this.state.filtered.length > 0;
        this.setState({ filtered: [], page: 0 }, () => { if (hadFilters) this.handleGetData(); });
    }

    handleRowClick = ({ id, index }) => {
        this.setState({ rowID: id, index });
    }

    render() {
        const { filtered, sorted, count, page, pageSize, data, getDataStatus, index, rowID } = this.state;

        return (
            <Wrapper>
                <div className="section">
                    <div className="row" style={{ marginTop: 0 }}>
                        <div className="col-lg-12">
                            <MariyaTable
                                propsGetDataStatus={getDataStatus}
                                handleChangePageSize={this.handleChangePageSize}
                                handleChangePage={this.handleChangePage}
                                count={count}
                                page={page}
                                pageSize={pageSize}
                                propsRowID={rowID}
                                propsRowClick={this.handleRowClick}
                                propsArray={data}
                                index={index}
                                handleOnFilterChange={this.handleOnFilterChange}
                                handleOnSortChange={this.handleOnSortChange}
                                filtered={filtered}
                                sorted={sorted} />
                            <Sidebar
                                onClear={this.handleClearFilter}
                                propsSelected={{ mariyaMovement: true }}
                                showAdministration={true} />
                        </div>
                    </div>
                </div>
            </Wrapper>
        );
    }
}

export default Mariya;
